export default __webpack_public_path__ + "static/media/image7.815ae41a.jpg";